import { Entity, Column, ManyToOne, JoinColumn, PrimaryGeneratedColumn } from 'typeorm'

import Survey from './Survey'
import Audience from './Audience'

@Entity('survey_audiences')
export default class SurveyAudience {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ name: 'created_at' })
  createdAt!: Date

  @ManyToOne(type => Survey, s => s.surveyAudiences)
  @JoinColumn({ name: 'survey_id' })
  survey!: Survey

  @ManyToOne(type => Audience, a => a.surveyAudiences)
  @JoinColumn({ name: 'audience_id' })
  audience!: Audience
}
